// /venues — Lista de salas
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { COLORS } from './designSystem';
import { EventsService } from './EventsService';
import { VenueTile, BottomNav, PhoneShell } from './components';

export default function VenuesListPage() {
  const navigate = useNavigate();
  const [venues, setVenues] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => { (async () => setVenues(await EventsService.getVenues()))(); }, []);
  const filtered = q ? venues.filter((v) => (v.name || '').toLowerCase().includes(q.toLowerCase())) : venues;
  return (
    <PhoneShell>
      <header className="px-5 pt-6 pb-4">
        <h1 className="text-white text-2xl font-extrabold mb-4">Venues</h1>
        <div className="flex items-center gap-2 px-4 py-3 rounded-full" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <Search size={18} color={COLORS.textMuted} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar sala…" className="flex-1 bg-transparent outline-none text-sm" style={{ color: COLORS.text }} data-testid="venues-search" />
        </div>
      </header>
      <section className="px-5 grid grid-cols-2 gap-3">
        {filtered.map((v) => (<VenueTile key={v.id} venue={v} size="large" onClick={() => navigate(`/venues/${v.id}`)} />))}
      </section>
      <BottomNav />
    </PhoneShell>
  );
}
